import {
    onActivated,
    onDeactivated,
    onMounted,
    onUnmounted,
    shallowRef,
    type MaybeRefOrGetter,
} from 'vue'

export interface DevToolbarEntry {
    id: string
    label: MaybeRefOrGetter<string>
    value: MaybeRefOrGetter<string>
    icon: MaybeRefOrGetter<string>
    loading?: MaybeRefOrGetter<boolean>
    /** When set, the row renders as a toggle switch reflecting this state. */
    toggle?: MaybeRefOrGetter<boolean>
    onClick: () => void
}

export const devToolbarEntries = shallowRef<DevToolbarEntry[]>([])

/**
 * Registers a page-specific entry in the global DevToolbar popover for the
 * lifetime of the calling component. Uses activated/deactivated as well as
 * mounted/unmounted so KeepAlive-cached pages only show their entry while
 * active.
 */
export function useDevToolbarEntry(entry: DevToolbarEntry): void {
    const remove = () =>
        (devToolbarEntries.value = devToolbarEntries.value.filter(
            e => e.id !== entry.id,
        ))
    const add = () => {
        devToolbarEntries.value = [
            ...devToolbarEntries.value.filter(e => e.id !== entry.id),
            entry,
        ]
    }
    onMounted(add)
    onActivated(add)
    onDeactivated(remove)
    onUnmounted(remove)
}
